import PlaceOrder from './components/PlaceOrder';

export default PlaceOrder;
